<template>
  <div
    ref="kt_modal_emitente_softwarehouse_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_emitente_softwarehouse_editar"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.guidEmitenteSoftwareHouse === ''">
            <img
              src="media/icons/duotune/coding/cod008.svg"
              class="me-2"
            />Vincular Empresa
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Vínculo
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="modalEditarEmitenteSoftwareHouse(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <div class="post d-flex flex-column-fluid pt-7 bg-lighten">
            <div class="container-xxl p-0" ref="errosGerais">
              <div
                v-if="loading"
                class="ms-7 mb-7"
                v-bind:data-kt-indicator="loading ? 'on' : 'off'"
              >
                <span class="indicator-progress">
                  Aguarde, carregando...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span>
                </span>
              </div>
              <div
                v-if="this.errosGerais.Message"
                class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
              >
                <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                  <inline-svg src="media/icons/duotune/general/gen044.svg" />
                </span>
                <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-bold">
                    <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                    <div class="fs-6 text-gray-600">
                      {{ this.errosGerais.Message }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!loading" class="d-flex flex-column flex-lg-row px-7">
                <div
                  class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10"
                >
                  <div class="d-flex flex-column gap-7 gap-lg-10">
                    <div class="card card-flush py-4">
                      <div class="card-header">
                        <div class="card-title">
                          <h2>Empresa</h2>
                        </div>
                      </div>
                      <div class="card-body pt-0">
                        <div
                          v-if="emitenteSoftwareHouse.Emitente"
                          @click="modalEmpresas(true)"
                          class="d-flex flex-column bg-light-info hoverable rounded border-info border border-dashed p-3"
                        >
                          <tr class="d-flex justify-content-between p-sm-4">
                            <td class="d-flex align-items-center">
                              <div
                                v-if="
                                  emitenteSoftwareHouse.Emitente
                                    ? emitenteSoftwareHouse.Emitente.logo
                                    : ''
                                "
                                class="symbol symbol-50px"
                              >
                                <div
                                  class="symbol-label fs-2 fw-bold bg-light-dark"
                                  :style="{
                                    'background-image': `url(${
                                      this.$utils.getUrl() +
                                      emitenteSoftwareHouse.Emitente.logo
                                    })`,
                                  }"
                                ></div>
                              </div>
                              <div v-else class="symbol symbol-50px">
                                <div
                                  :class="[
                                    'symbol-label fs-2 fw-bold ' +
                                      emitenteSoftwareHouse.color,
                                  ]"
                                >
                                  {{
                                    emitenteSoftwareHouse.Emitente
                                      ? emitenteSoftwareHouse.Emitente.nome
                                          .substring(0, 1)
                                          .toUpperCase()
                                      : ""
                                  }}
                                </div>
                              </div>
                            </td>
                            <td class="d-flex align-items-center px-4">
                              <div>
                                <span
                                  class="text-dark fw-bolder text-hover-primary"
                                >
                                  {{
                                    emitenteSoftwareHouse.Emitente
                                      ? emitenteSoftwareHouse.Emitente.nome
                                      : ""
                                  }}
                                </span>
                                <span class="text-muted fw-bold d-block fs-7">
                                  {{
                                    emitenteSoftwareHouse.Emitente
                                      ? this.$utils.setMask(
                                          emitenteSoftwareHouse.Emitente.cnpj,
                                          "##.###.###/####-##",
                                          true
                                        )
                                      : ""
                                  }}
                                </span>
                              </div>
                            </td>
                            <td class="d-flex align-items-center">
                              <button
                                type="button"
                                class="btn btn-sm rounded-circle btn-light-info btn-active-light-info m-0 p-4"
                              >
                                <span class="svg-icon svg-icon-2hx m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen055.svg"
                                /></span>
                              </button>
                            </td>
                          </tr>
                        </div>
                        <div
                          v-else
                          @click="modalEmpresas(true)"
                          class="d-flex flex-column bg-light-info hoverable rounded border-info border border-dashed p-3"
                        >
                          <tr class="d-flex justify-content-between p-sm-4">
                            <td class="d-flex align-items-center px-4">
                              <div class="text-start">
                                <span class="text-dark fw-bolder fs-6">
                                  Selecione uma Empresa
                                </span>
                              </div>
                            </td>
                            <td class="d-flex align-items-center">
                              <button
                                type="button"
                                class="btn btn-sm rounded-circle btn-light-info btn-active-light-info m-0 p-4"
                              >
                                <span class="svg-icon svg-icon-2hx m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen004.svg"
                                /></span>
                              </button>
                            </td>
                          </tr>
                        </div>
                      </div>
                      <div class="card-header">
                        <div class="card-title">
                          <h2>SoftwareHouse</h2>
                        </div>
                      </div>
                      <div class="card-body pt-0">
                        <div
                          v-if="emitenteSoftwareHouse.SoftwareHouse"
                          @click="modalSoftwareHouses(true)"
                          class="d-flex flex-column bg-light-info hoverable rounded border-info border border-dashed p-3"
                        >
                          <tr class="d-flex justify-content-between p-sm-4">
                            <td class="d-flex align-items-center">
                              <div
                                v-if="
                                  emitenteSoftwareHouse.SoftwareHouse
                                    ? emitenteSoftwareHouse.SoftwareHouse.logo
                                    : ''
                                "
                                class="symbol symbol-50px"
                              >
                                <div
                                  class="symbol-label fs-2 fw-bold bg-light-dark"
                                  :style="{
                                    'background-image': `url(${
                                      this.$utils.getUrl() +
                                      emitenteSoftwareHouse.SoftwareHouse.logo
                                    })`,
                                  }"
                                ></div>
                              </div>
                              <div v-else class="symbol symbol-50px">
                                <div
                                  :class="[
                                    'symbol-label fs-2 fw-bold ' +
                                      emitenteSoftwareHouse.color,
                                  ]"
                                >
                                  {{
                                    emitenteSoftwareHouse.SoftwareHouse
                                      ? emitenteSoftwareHouse.SoftwareHouse.nome
                                          .substring(0, 1)
                                          .toUpperCase()
                                      : ""
                                  }}
                                </div>
                              </div>
                            </td>
                            <td class="d-flex align-items-center px-4">
                              <div>
                                <span
                                  class="text-dark fw-bolder text-hover-primary"
                                >
                                  {{
                                    emitenteSoftwareHouse.SoftwareHouse
                                      ? emitenteSoftwareHouse.SoftwareHouse.nome
                                      : ""
                                  }}
                                </span>
                                <span class="text-muted fw-bold d-block fs-7">
                                  {{
                                    emitenteSoftwareHouse.SoftwareHouse
                                      ? this.$utils.setMask(
                                          emitenteSoftwareHouse.SoftwareHouse
                                            .cnpj,
                                          "##.###.###/####-##",
                                          true
                                        )
                                      : ""
                                  }}
                                </span>
                              </div>
                            </td>
                            <td class="d-flex align-items-center">
                              <button
                                type="button"
                                class="btn btn-sm rounded-circle btn-light-info btn-active-light-info m-0 p-4"
                              >
                                <span class="svg-icon svg-icon-2hx m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen055.svg"
                                /></span>
                              </button>
                            </td>
                          </tr>
                        </div>
                        <div
                          v-else
                          @click="modalSoftwareHouses(true)"
                          class="d-flex flex-column bg-light-info hoverable rounded border-info border border-dashed p-3"
                        >
                          <tr class="d-flex justify-content-between p-sm-4">
                            <td class="d-flex align-items-center px-4">
                              <div class="text-start">
                                <span class="text-dark fw-bolder fs-6">
                                  Selecione um SoftwareHouse
                                </span>
                              </div>
                            </td>
                            <td class="d-flex align-items-center">
                              <button
                                type="button"
                                class="btn btn-sm rounded-circle btn-light-info btn-active-light-info m-0 p-4"
                              >
                                <span class="svg-icon svg-icon-2hx m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen004.svg"
                                /></span>
                              </button>
                            </td>
                          </tr>
                        </div>
                      </div>
                      <div class="card-body pt-5">
                        <div class="mb-0 fv-row">
                          <label class="form-label me-15">Bloquear</label>
                          <div class="btn-group w-50">
                            <label
                              type="button"
                              class="btn text-muted text-hover-white text-active-white btn-outline btn-active-success"
                              :class="[
                                this.emitenteSoftwareHouse.bloqueado === '1' &&
                                  'active',
                              ]"
                            >
                              <input
                                class="btn-check"
                                type="radio"
                                @click="
                                  this.emitenteSoftwareHouse.bloqueado = '1'
                                "
                              />
                              SIM
                            </label>
                            <label
                              class="btn text-muted text-hover-white text-active-white btn-outline btn-active-success"
                              :class="[
                                this.emitenteSoftwareHouse.bloqueado === '0' &&
                                  'active',
                              ]"
                            >
                              <input
                                class="btn-check"
                                type="radio"
                                @click="
                                  this.emitenteSoftwareHouse.bloqueado = '0'
                                "
                              />
                              NÃO
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end py-6 px-9">
                <button
                  class="btn btn-danger svg-icon-white me-2 mb-2"
                  data-bs-dismiss="modal"
                  @click="modalEditarEmitenteSoftwareHouse(false)"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr015.svg"
                      class="me-2"
                    />Cancelar
                  </span>
                </button>
                <button
                  class="btn btn-success svg-icon-white mb-2"
                  @click="confirmarEmitenteSoftwareHouse()"
                  v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span class="svg-icon svg-icon-1" v-if="!this.loading">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr016.svg"
                      class="me-2"
                    />Confirmar
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <EmpresasModal
    v-if="exibirEmpresas"
    @exibirModalEmitente="modalEmpresas"
    @selecionarEmitente="selecionarEmitente"
  ></EmpresasModal>
  <SoftwareHousesModal
    v-if="exibirSoftwareHouses"
    @exibirModalSoftwareHouse="modalSoftwareHouses"
    @selecionarSoftwareHouse="selecionarSoftwareHouse"
  ></SoftwareHousesModal>
</template>

<script>
import EmpresasModal from "../empresas/EmpresasModal.vue";
import SoftwareHousesModal from "../softwarehouse/SoftwareHousesModal.vue";
import {
  hideModal,
  showModal,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  emits: ["exibirModalEmitenteSoftwareHouse", "atualizarEmitenteSoftwareHouse"],
  components: { EmpresasModal, SoftwareHousesModal },
  props: {
    guidEmitenteSoftwareHouse: { type: String, required: true },
  },
  methods: {
    //Emits EmpresasModal
    modalEmpresas(exibir) {
      this.exibirEmpresas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_empresas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarEmpresas");
          },
          /*close*/ () => {
            this.modalEmpresas(false);
          }
        );
      }
    },
    selecionarEmitente(emitente) {
      this.emitenteSoftwareHouse.Emitente = emitente;
      this.emitenteSoftwareHouse.id_empresa = emitente.id;
    },
    //Emits SoftwareHousesModal
    modalSoftwareHouses(exibir) {
      this.exibirSoftwareHouses = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_softwarehouses_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarSoftwareHouses");
          },
          /*close*/ () => {
            this.modalSoftwareHouses(false);
          }
        );
      }
    },
    selecionarSoftwareHouse(softwareHouse) {
      this.emitenteSoftwareHouse.SoftwareHouse = softwareHouse;
      this.emitenteSoftwareHouse.id_software_house = softwareHouse.id;
    },
    //Emits EmitenteSoftwareHouseModal
    modalEditarEmitenteSoftwareHouse(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalEmitenteSoftwareHouse", false);
      }
    },
    async confirmarEmitenteSoftwareHouse() {
      this.errosGerais = {};
      this.loading = true;

      if (this.add === true) {
        this.emitenteSoftwareHouse.guid = this.$utils.generateUuidv4();
        try {
          var ret = await this.$store.dispatch(
            "emitenteSoftwareHouse/postEmitenteSoftwareHouse",
            this.emitenteSoftwareHouse
          );
          if (ret.Success === true) {
            toast.success("Empresa vinculada com sucesso!", { timeout: 3000 });
            this.$emit("atualizarEmitenteSoftwareHouse");
            this.modalEditarEmitenteSoftwareHouse(false);
            hideModal(this.$refs.kt_modal_emitente_softwarehouse_editar);
          }
        } catch (error) {
          this.errosGerais = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "emitenteSoftwareHouse/putEmitenteSoftwareHouse",
            this.emitenteSoftwareHouse
          );
          if (retPut.Success === true) {
            toast.success("Empresa atualizada com sucesso!", { timeout: 3000 });
            this.$emit("atualizarEmitenteSoftwareHouse");
            this.modalEditarEmitenteSoftwareHouse(false);
            hideModal(this.$refs.kt_modal_emitente_softwarehouse_editar);
          }
        } catch (error) {
          this.errosGerais = error;
        }
      }

      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }

      this.loading = false;
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async carregarEmitenteSoftwareHouse() {
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch(
          "emitenteSoftwareHouse/getEmitenteSoftwareHouse",
          this.guidEmitenteSoftwareHouse
        );
        if (ret.Data !== null) {
          Object.assign(ret.Data, {
            color: this.$utils.getColorRandom(),
          });
          this.emitenteSoftwareHouse = ret.Data;
        } else {
          this.errosGerais = ret;
        }
      } catch (error) {
        this.errosGerais = error;
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    limparEmitenteSoftwareHouse() {
      this.emitenteSoftwareHouse = {
        id_empresa: 0,
        id_software_house: 0,
        guid: "",
        bloqueado: "0",
      };

      this.errosGerais = {};
    },
    async asyncData() {
      if (this.guidEmitenteSoftwareHouse !== "") {
        this.loading = true;
        this.add = false;
        await this.carregarEmitenteSoftwareHouse();
      } else {
        this.add = true;
        this.limparEmitenteSoftwareHouse();
      }
    },
  },
  mounted() {
    this.asyncData();
  },
  data() {
    return {
      exibirEmpresas: false,
      exibirSoftwareHouses: false,
      add: false,
      loading: false,
      errosGerais: {},
      emitenteSoftwareHouse: {
        id_empresa: 0,
        id_software_house: 0,
        guid: "",
        bloqueado: "0",
      },
    };
  },
};
</script>

<style></style>
